<template>
    <div>
        <modal :name="modal_name" class="final-modal policy-modal" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;">
                <div class="v-modal-header">
                    <span class="v-modal-dialog-title v-modal-title">Change Password</span>
                </div>
                <div class="v-modal-body pt-4 pb-0">
                    <div class="v-modal-layout d-form" style="overflow: initial !important;">
                        <div>
                            <div class="form-group pt-2">
                                <span class="fs-14">Enter Previous Password</span>
                                <input name="previous_pass" data-vv-as="Previous Password" @blur="checkOldPwd" v-model="previousPass" :maxlength="passwordlength" class="inputContacts pt-2" type="password" v-validate="'required'" placeholder="Enter Previous Password" />
                                <span class="highlightContact"></span>
                            </div>
                            <span class="invalid-feedback-form text-danger fs-13" v-show="errors.has('previous_pass')">{{ errors.first('previous_pass')}}</span>
                            <span class="invalid-feedback-form text-danger fs-13" v-if="wrongOldPwd && previousPass.length">Wrong Password</span>
                            <span class="pull-right text-right fs-12 pt-1">{{ passwordlength - previousPass.length}}/{{passwordlength}}</span>
                        </div>
                        <div class="mt-2">
                            <div class="form-group pt-2">
                                <span class="fs-14">Enter New Password</span>
                                <input name="new_pass" data-vv-as="New Password" @input="checkNewPwd" v-model="newPass" :maxlength="passwordlength" class="inputContacts pt-2" type="password" v-validate="'required'" placeholder="Enter New Password" />
                                <span class="highlightContact"></span>
                            </div>
                            <span class="invalid-feedback-form text-danger fs-13" v-show="errors.has('new_pass')">{{ errors.first('new_pass')}}</span>
                            <span class="pull-right text-right fs-12 pt-1">{{ passwordlength - newPass.length}}/{{passwordlength}}</span>
                        </div>
                        <div class="mt-2">
                            <div class="form-group pt-2">
                                <span class="fs-14">Confirm Password</span>
                                <input name="confirm_pass" data-vv-as="Confirm Password" @input="checkNewPwd" v-model="confirmPass" :maxlength="passwordlength" class="inputContacts pt-2" type="password" v-validate="'required'" placeholder="Enter Confirm Password" />
                                <span class="highlightContact"></span>
                            </div>
                            <span class="invalid-feedback-form text-danger fs-13" v-show="errors.has('confirm_pass')">{{ errors.first('confirm_pass')}}</span>
                            <span class="pull-right text-right fs-12 pt-1">{{ passwordlength - confirmPass.length}}/{{passwordlength}}</span>
                        </div>
                    </div>
                </div>
                <div class="v-modal-dialog-actions modal-bg" style="border-radius: 0px 0px 15px 15px;">
                    <a class="btn btn-danger text-white btn-smm" @click="cancel()">Cancel</a>
                    <button class="btn btn-success text-white ml-4 btn-smm text-uppercase" @click="save()">Save</button>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import setting from '../mixins/setting.js';
import { SweetModal } from 'sweet-modal-vue';
export default {
    props:['modal_name','password'],
    mixins:[setting],
    components:{
        SweetModal
    },
    data(){
        return{
            previousPass:'',
            newPass:'',
            confirmPass:'',
            passwordlength:100,
            wrongOldPwd:false,
            pwdMismatch:false,
            success_msg:'',
            warning_msg:''
        }
    },
    methods:{
        checkOldPwd(){
            if(this.password == this.previousPass){
                this.wrongOldPwd = false
            }else{
                this.wrongOldPwd = true
            }
        },
        checkNewPwd(){
            if(this.newPass == this.confirmPass){
                this.pwdMismatch = false
            }else{
                this.pwdMismatch = true
            }
        },
        save(){
            this.$validator.validateAll().then(result => {
                if (result == true && !this.pwdMismatch && !this.wrongOldPwd){
                    this.confirmSave()
                }else if(this.wrongOldPwd){
                    this.$toasted.global.error("Wrong Previous Password")
                }else if(this.pwdMismatch){
                    this.$toasted.global.error("Password confirmation must match New Password")
                }
                else{
                    this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async confirmSave(){
            try {
                let res = await this.changePassword(this.create_json)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.cancel()
                    this.$emit('pwdUpdated')
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        cancel(){
            this.$modal.hide(this.modal_name)
            this.confirmPass = ''
            this.newPass = ''
            this.previousPass = ''
        }
    },
    computed:{
        create_json(){
            return{
                confirm_password:this.confirmPass,
                new_password:this.newPass,
                previous_password:this.previousPass
            }
        }
    },
    created(){
        const dict = {
            custom: {
                previous_pass:{
                    required:() => "Previous Password is Required",
                },
                new_pass:{
                    required:() => "New Password is Required",
                },
                confirm_pass:{
                    required:() => "Confirm Password is Required",
                },
            }
        }
        this.$validator.localize("en", dict); 
    },
}
</script>
<style scoped>
  .inputContacts {
    font-size: 18px;
    padding: 10px;
    display: block;
    width: 100%;
    border: none;
    color: #303031 !important;
    background-color: #ffffff;
    border-radius: 4px;
    font-weight: 500;
    margin-top: 10px;
  }
</style>